import { t } from '../../app/i18n';

export default {
  BANK: 'BANK',
  ACCOUNT: 'ACCOUNT',
};

export const translation = {
  BANK: t('Bankový účet'),
  ACCOUNT: t('Virtuálny účet'),
};



// WEBPACK FOOTER //
// ./src/common/enums/paymentDestination.js